import classes from './Bubble.module.css';
import type { BubbleKind, BubbleRole } from './bubble-types.ts';
import { HudBox } from '#plugin-chat/components/hud/HudBox.tsx';

export interface BubbleProps {
  role: BubbleRole;
  kind?: BubbleKind;
  children: React.ReactNode;
  corners?: ('tl' | 'tr' | 'bl' | 'br')[];
}

/** Animated chat message bubble with role-based styling and optional visual variants. */
export function Bubble({ role, kind, children, ...props }: BubbleProps) {
  return (
    <div className={classes.bubble}>
      <HudBox
        accentHue={240}
        bevel={10}
        cornerLength={60}
        corners={role === 'user' ? [] : ['tl', 'br']}
        cornerThickness={4}
        particleCount={role === 'assistant' ? 0 : 0}
        primaryHue={250}
        sharpCorners={role === 'user' ? ['br'] : ['bl']}
        strokeWidth={1}
        style={
          {
            '--hud-background-opacity': role === 'assistant' ? 0.0 : 1,
            '--hud-glow-opacity': role === 'assistant' ? 0.075 : 0.4,
          } as React.CSSProperties
        }
        {...props}
      >
        {/* {role === 'assistant' && ( */}
        {/*   <div className={classes.roleLabel}>{role === 'user' ? 'You' : 'AiPSO Intelligent Assistant'}</div> */}
        {/* )} */}
        <div className={classes.content}>{children}</div>
      </HudBox>
    </div>
  );
}
